var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon",attrs:{"tooltip":_vm.tooltip}},[_c('font-awesome-icon',_vm._b({attrs:{"icon":[_vm.prefix, _vm.icon]}},'font-awesome-icon',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }